export const MALWARE_CONFIG_ANNOTATION = {
  C2: "malware_config_c2",
  PATH: "malware_config_path",
  MUTEX: "malware_config_mutex"
} as const;

export const MALWARE_CONFIG_C2_TOOLTIP = "Used as a C2 Server";

export const MALICIOUS_FILES_TOOLTIP = "Malicious file(s) downloaded.";

export const MALWARE_CONFIG_C2_ICON = "c2";

export const MALWARE_CONFIG_ICON = "skull";

export const MALWARE_CONFIG_TOOLTIP = "Found in the malware configuration";

export const MALICIOUS_FILES_ICON = "file-1";
